import { normalizePairingCode } from "@racler/shared";

export const PENDING_PAIRING_CODE_KEY = "racler:pending_pairing_code";

/**
 * Extracts a pairing code from a URL hash fragment (e.g. "#code=ABCD-1234" or "code=ABCD-1234").
 * Returns the raw string value of code parameter if present, or null.
 */
export function extractPairingCode(hash: string): string | null {
  if (!hash) return null;
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  try {
    const params = new URLSearchParams(raw);
    const code = params.get("code");
    return code ? code.trim() : null;
  } catch {
    return null;
  }
}

/**
 * Validates and normalizes a pairing code. Returns canonical 8-character string or null if invalid.
 */
export function validatePairingCode(code: string): string | null {
  return normalizePairingCode(code);
}

export function getPendingPairingCode(): string | null {
  try {
    return sessionStorage.getItem(PENDING_PAIRING_CODE_KEY);
  } catch {
    return null;
  }
}

export function setPendingPairingCode(code: string): void {
  try {
    sessionStorage.setItem(PENDING_PAIRING_CODE_KEY, code);
  } catch {
    // sessionStorage might be disabled or throw in restricted contexts
  }
}

export function clearPendingPairingCode(): void {
  try {
    sessionStorage.removeItem(PENDING_PAIRING_CODE_KEY);
  } catch {
    // ignore
  }
}

/**
 * Removes the hash from the browser address bar without triggering a reload or route change.
 */
export function clearUrlHash(): void {
  if (typeof window === "undefined" || !window.history || !window.location) return;
  if (window.location.hash) {
    const cleanUrl = window.location.pathname + window.location.search;
    window.history.replaceState(null, "", cleanUrl);
  }
}
